export type ShortcutKind = "palette" | "slash";

// Decides whether a global keyboard shortcut (⌘K / "/") must leave the event
// alone: during IME composition, while a modal is open, and (for "/") while
// the user is typing in an editable element.
export function shouldIgnoreGlobalShortcut(
  event: KeyboardEvent,
  doc: Document,
  kind: ShortcutKind,
): boolean {
  if (event.isComposing) return true;
  if (doc.querySelector('[data-modal-open="1"]')) return true;
  if (kind === "palette") return false;
  const target = event.target as HTMLElement | null;
  if (!target || typeof target.closest !== "function") return false;
  // isContentEditable also covers contenteditable="plaintext-only" and
  // editability inherited from an ancestor, which the selector cannot see.
  if (target.isContentEditable) return true;
  return (
    target.closest(
      'input, textarea, select, [contenteditable=""], [contenteditable="true"]',
    ) !== null
  );
}
